import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const maquinariasStore = createCrudStore("maquinaria");

export default {
  ...maquinariasStore,

  getters: {
    ...maquinariasStore.getters,
    maquinarias(state) {
      return Array.isArray(state.maquinaria) ? state.maquinaria : [];
    },
  },

  actions: {
    ...maquinariasStore.actions,
    getMaquinarias: maquinariasStore.actions.getAllStates,
    postMaquinaria: maquinariasStore.actions.create,
    patchMaquinaria: maquinariasStore.actions.update,
    deleteMaquinaria: maquinariasStore.actions.delete,

    async postArreglo({ dispatch }, { maquinaria_id, arreglo }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(
            `maquinaria/arreglo?maquinaria_id=${maquinaria_id}`,
            arreglo
          ),
        onSuccessCallback: async () => {
          await dispatch("getMaquinarias");
          console.log("✅ Arreglo registrado correctamente");
        },
        errorMessage: "Error al registrar arreglo",
      });
    },

    async getArreglos({ commit }, maquinaria_id) {
      commit("setLoading", true);
      try {
        const url = `maquinaria/${maquinaria_id}/arreglos`;
        const response = await apiService.getCustom(url);
        return response.data;
      } catch (error) {
        commit("setError", "Error al obtener arreglos");
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },

    async getSeguros(_, { maquinaria_id, soloActivos = false }) {
      const url = `maquinaria/${maquinaria_id}/seguros${
        soloActivos ? "?solo_activos=true" : ""
      }`;
      const response = await apiService.getCustom(url);
      return response.data;
    },

    async postSeguro(_, { maquinaria_id, seguro }) {
      const response = await apiService.postCustom(
        `maquinaria/${maquinaria_id}/seguros`,
        seguro
      );
      return response.data;
    },

    async putSeguro(_, { maquinaria_id, seguro_id, seguro }) {
      const response = await apiService.putCustom(
        `maquinaria/${maquinaria_id}/seguros/${seguro_id}`,
        seguro
      );
      return response.data;
    },

    async deleteSeguro(_, { maquinaria_id, seguro_id }) {
      await apiService.deleteCustom(
        `maquinaria/${maquinaria_id}/seguros/${seguro_id}`
      );
    },

    // ─── COMBUSTIBLE MÁQUINAS ───
    async getCargasCombustible(_, maquinaria_id) {
      const response = await apiService.getCustom(
        `maquinaria/${maquinaria_id}/combustible`
      );
      return response.data;
    },

    async postCargaCombustible(_, { maquinaria_id, carga }) {
      const response = await apiService.postCustom(
        `maquinaria/${maquinaria_id}/combustible`,
        carga
      );
      return response.data;
    },

    async deleteCargaCombustible(_, carga_id) {
      await apiService.deleteCustom(`maquinaria/combustible/carga/${carga_id}`);
    },

    // ─── COMBUSTIBLE ───
    async getComprasCombustible(_, { desde, hasta } = {}) {
      let url = `maquinaria/combustible/compra`;
      const params = new URLSearchParams();
      if (desde) params.append("desde", desde);
      if (hasta) params.append("hasta", hasta);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await apiService.getCustom(url);
      return response.data;
    },

    async postCompraCombustible(_, compra) {
      const response = await apiService.postCustom(
        `maquinaria/combustible/compra`,
        compra
      );
      return response.data;
    },

    async putCompraCombustible(_, { compra_id, compra }) {
      const response = await apiService.putCustom(
        `maquinaria/combustible/compra/${compra_id}`,
        compra
      );
      return response.data;
    },

    async deleteCompraCombustible(_, compra_id) {
      await apiService.deleteCustom(
        `maquinaria/combustible/compra/${compra_id}`
      );
    },

    async getEstadisticasCombustible() {
      const response = await apiService.getCustom(
        `maquinaria/combustible/estadisticas`
      );
      return response.data;
    },

    async putCombustibleConfig(_, config) {
      const response = await apiService.putCustom(
        `maquinaria/combustible/config`,
        config
      );
      return response.data;
    },

    async getCombustibleStatus() {
      const response = await apiService.getCustom(
        `maquinaria/combustible/status`
      );
      return response.data;
    },
  },
};
